import { Component, OnInit } from '@angular/core';

@Component({
  moduleId: module.id,
  selector: 'second-navbar',
  templateUrl: 'second-navbar.component.html',
  styleUrls: ['second-navbar.component.scss'],
  host: {'class': 'second-navbar'}
})
export class SecondNavbarComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/ui/second-navbar/second-navbar.component.ts